import { Dashboard } from '@mui/icons-material';
import {
  Add_New_users,
  Assign_Leads_Admin_Marketer,
  AssignleadinteamleaderType,
  DashboardForManager_CRMData_Type,
  DashboardForManager_Type,
  Delete_User,
  Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
  Get_ALL_Stages_With_LeadsCount_For_Admin,
  Get_ALL_Stages_With_LeadsCount_For_Marketer,
  Get_ALL_Stages_With_LeadsCount_For_Marketer_CRM_DATA,
  Get_All_Top_Saler,
  Get_All_Top_Saler_by_monthyear,
  Get_All_users,
  Get_All_users_Depending_on_Sales,
  Get_Error,
  Get_One_Client,
  recieveusertoleadtype,
  SALES_LEADS_REPORT_LOADING,
  SALES_LEADS_REPORT_SUCCESS,
  SOCKET_NEW_LEAD,
  Update_Client,
  UpdateStage,
  SalesRequestData_Type,
  GetAll_SalesRequestData_Type,
} from '../Types';

const intial = {
  Get_users: [],
  Get_users_Fresh_Lead: [],
  Get_users_Follow_UP: [],
  All_Top_Saller: [],
  Get_Leads_For_Marketer: [],
  Get_users_Depending_On_sales: [],
  AssignLeadsAdminMarketer: [],
  Stages_With_LeadsCount: [],
  Stages_With_LeadsCount_Marketer: [],
  Stages_With_LeadsCount_Marketer_CRM_DATA: [],
  DashboardForManager: [],
  DashboardForManagercrmdata: [],
  LeadsFORMAnagercrmdata: [],
  updateclient2torecieveusertolead: [],
  Assignleadesinteamleader: [],
  salesLeadsReport: null,
  SalesRequestData:[],
  GetAll_SalesRequestData:[],
  loading: true,
};

const UsersReducers = (state = intial, action) => {
  switch (action.type) {
    case Get_All_users:
      return {
        ...state,
        Get_users: action.payload,
        loading: false,
      };

    case SOCKET_NEW_LEAD: // معالجة حدث Socket.io الجديد
      return {
        ...state,
        Get_users: {
          ...state.Get_users,
          data: [action.payload, ...state.Get_users.data],
        },
      };
    case Add_New_users:
      return {
        Get_users: action.payload,
        loading: false,
      };

    case Delete_User:
      return {
        Get_users: action.payload,
        loading: false,
      };
    case Update_Client:
      return {
        Get_users: action.payload,
        loading: false,
      };
    case Get_One_Client:
      return {
        Get_users: action.payload,
        loading: false,
      };

    case UpdateStage:
      return {
        Get_users: action.payload,
        loading: false,
      };

    case Get_All_Top_Saler:
      return {
        All_Top_Saller: action.payload,
        loading: false,
      };

    //  get leads for marketer user by user of email
    // case Get_All_Leads_For_Role_By_email_MarketerLeads_Type:
    //     return{
    //         Get_Leads_For_Marketer:action.payload,
    //         loading:false,
    //     }

    //   top sales by quarter in sales هتلاقيني عاملها في ال sales فاهم
    // ⚠️ أضف هذه الحالات للتقرير
    case SALES_LEADS_REPORT_SUCCESS:
      return {
        ...state,
        salesLeadsReport: action.payload,
        loading: false,
        error: null,
      };

    case SALES_LEADS_REPORT_LOADING:
      return {
        ...state,
        salesLeadsReport: {
          ...state.salesLeadsReport,
          loading: action.payload,
          ...(action.payload === true ? { error: null } : {}), // نمسح الـ error لما نبدأ loading جديد
        },
      };

    case Get_All_users_Depending_on_Sales:
      return {
        ...state,
        Get_users_Depending_On_sales: action.payload,
        loading: false,
      };

    case DashboardForManager_Type:
      return {
        ...state,
        DashboardForManager: action.payload,
        loading: false,
      };

    case DashboardForManager_CRMData_Type:
      return {
        ...state,
        DashboardForManagercrmdata: action.payload,
        loading: false,
      };

    case Assign_Leads_Admin_Marketer:
      return {
        ...state,
        AssignLeadsAdminMarketer: action.payload,
        loading: false,
      };

    case Get_ALL_Stages_With_LeadsCount_For_Admin:
      return {
        ...state,
        Stages_With_LeadsCount: action.payload,
        loading: false,
      };

    case Get_ALL_Stages_With_LeadsCount_For_Marketer:
      return {
        ...state,
        Stages_With_LeadsCount_Marketer: action.payload,
        loading: false,
      };

    case Get_ALL_Stages_With_LeadsCount_For_Marketer_CRM_DATA:
      return {
        ...state,
        Stages_With_LeadsCount_Marketer_CRM_DATA: action.payload,
        loading: false,
      };

    case recieveusertoleadtype:
      return {
        ...state,
        updateclient2torecieveusertolead: action.payload,
        loading: false,
      };

    case AssignleadinteamleaderType:
      return {
        ...state,
        Assignleadesinteamleader: action.payload,
        loading: false,
      };


      
     case SalesRequestData_Type:
      return{
    SalesRequestData:action.payload,
    loading:false,
    }

       case GetAll_SalesRequestData_Type:
      return{
    GetAll_SalesRequestData:action.payload,
    loading:false,
    }


        

    case Get_Error:
      return {
        loading: true,
        Get_users: action.payload,
      };
    default:
      return state;
  }
};

export default UsersReducers;
